import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PolizaEficasia2025 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/251118-Poliza-de-Servicios-X440-G2-48P.pdf`;
  /*const pdfUrl = "/pdf/251118-Poliza-de-Servicios-X440-G2-48P.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Póliza 2025</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Póliza 2025" />
      </Container>
    </>
  );
};

 export default PolizaEficasia2025;
